/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts () {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  webFontLoader.load({
    google: {
      /* DM Sans (UI) + Sora (titles / emphasis) — matches Portal 3.0 */
      families: [
        "DM+Sans:300,400,500,600,700&display=swap",
        "Sora:300,400,500,600,700&display=swap",
      ],
    },
  })
}
